import React, { useState } from 'react';
import '../assets/Drivers.css';

interface AddDriverModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (name: string, phone: string) => void;
}

export const AddDriverModal: React.FC<AddDriverModalProps> = ({ isOpen, onClose, onAdd }) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) return;
    // Keep the values: the parent closes this only once the add succeeds, so a
    // failed submit does not make the user retype everything.
    onAdd(name.trim(), phone.trim());
  };

  const cancel = () => {
    setName('');
    setPhone('');
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={cancel}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Add driver</h2>
          <p className="modal-subtitle">They’ll receive routes on WhatsApp.</p>
        </div>

        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="driver-name">Name</label>
            <input id="driver-name" className="form-input" value={name}
                   onChange={e => setName(e.target.value)} placeholder="Ahmed Ali" required />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="driver-phone">Phone</label>
            <input id="driver-phone" className="form-input" type="tel" value={phone}
                   onChange={e => setPhone(e.target.value)} placeholder="+974 3312 4455" required />
            <span className="form-help">Include the country code.</span>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn--secondary" onClick={cancel}>Cancel</button>
            <button type="submit" className="btn btn--primary">Add driver</button>
          </div>
        </form>
      </div>
    </div>
  );
};
